var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Dot } from '@components';
import { SuperintendentBookingBusiness } from '@business/superintendentBooking';
import { SuperintendentBookingStatus, SuperintendentLinkRevokedReason } from '@common/enums/superintendentBooking';
import { ARRIVAL_WINDOW_NOTE, BRAND_NAME, CONTACT_PHONE, CONTACT_PHONE_HREF, downloadIcs, formatAddress, formatArrivalWindow, formatCityState, formatCompactRange, formatClock, formatCutoff, formatDayHeading, formatDuration, formatDurationPhrase, formatFullDate, formatLongDate, formatShortDate, formatStreet, formatTimeRange, formatClosedDate, getGoogleCalendarUrl, getOutlookCalendarUrl, getVisitCopy, getWindowDays } from './utils';
import { CalendarIcon, CalendarPlusIcon, CheckCircleIcon, CheckIcon, ChevronDownIcon, ChevronLeftIcon, ClockIcon, HomeIcon, LinkOffIcon, PersonIcon, PhoneIcon, PinIcon, XCircleIcon } from './icons';
import "./index.less";
var SuperintendentBooking = /** @class */ (function (_super) {
    __extends(SuperintendentBooking, _super);
    function SuperintendentBooking() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isCalendarMenuOpen: false };
        _this.headingRef = React.createRef();
        _this.moreHeadingRef = React.createRef();
        _this.lastScreen = null;
        return _this;
    }
    SuperintendentBooking.prototype.componentDidMount = function () {
        this.props.init();
    };
    SuperintendentBooking.prototype.componentDidUpdate = function (prevProps) {
        var _a, _b;
        // Opening More times hides its button, so focus moves to the section it revealed.
        if (!prevProps.isMoreTimesOpen && this.props.isMoreTimesOpen) {
            (_a = this.moreHeadingRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        var screen = this.getScreen();
        if (this.lastScreen && screen !== this.lastScreen && screen !== 'loading') {
            (_b = this.headingRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
        if (screen !== 'loading') {
            this.lastScreen = screen;
        }
    };
    SuperintendentBooking.prototype.getScreen = function () {
        var _a = this.props, isDetailLoadFailed = _a.isDetailLoadFailed, isPageLoading = _a.isPageLoading, detail = _a.detail, isRescheduling = _a.isRescheduling, isJustBooked = _a.isJustBooked, isTimesLoadFailed = _a.isTimesLoadFailed, isTimesLoading = _a.isTimesLoading, step = _a.step, selectedSlot = _a.selectedSlot, replacedBooking = _a.replacedBooking;
        if (isDetailLoadFailed) {
            return 'loadError';
        }
        if (isPageLoading || !detail) {
            return 'loading';
        }
        if (detail.status === SuperintendentBookingStatus.Bookable) {
            if (detail.booking && !isRescheduling) {
                if (!isJustBooked) {
                    return 'scheduled';
                }
                return replacedBooking ? 'rescheduled' : 'booked';
            }
            if (isTimesLoadFailed) {
                return 'loadError';
            }
            if (isTimesLoading) {
                return 'loading';
            }
            return step === 'confirm' && selectedSlot ? 'confirm' : 'pick';
        }
        if (detail.status === SuperintendentBookingStatus.LinkReplaced && detail.revokedReason === SuperintendentLinkRevokedReason.Cancelled) {
            return 'cancelled';
        }
        if (detail.status === SuperintendentBookingStatus.LinkExpired || detail.status === SuperintendentBookingStatus.WindowClosed) {
            return 'expired';
        }
        return 'notRecognized';
    };
    Object.defineProperty(SuperintendentBooking.prototype, "copy", {
        get: function () {
            var _a;
            return getVisitCopy((_a = this.props.detail) === null || _a === void 0 ? void 0 : _a.visitTypeId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperintendentBooking.prototype, "cutoff", {
        get: function () {
            var _a;
            var closedOn = (_a = this.props.detail) === null || _a === void 0 ? void 0 : _a.bookingClosedOn;
            return closedOn ? formatCutoff(closedOn) : null;
        },
        enumerable: false,
        configurable: true
    });
    SuperintendentBooking.prototype.slotTime = function (slot, withZone) {
        if (withZone === void 0) { withZone = false; }
        return this.copy.isArrivalWindow ? formatArrivalWindow(slot, withZone) : formatTimeRange(slot, withZone);
    };
    SuperintendentBooking.prototype.chipRange = function (slot) {
        return this.copy.isArrivalWindow ? formatCompactRange(slot) : formatTimeRange(slot);
    };
    SuperintendentBooking.prototype.slotSub = function (slot) {
        return this.copy.isArrivalWindow ? ARRIVAL_WINDOW_NOTE : formatDuration(slot);
    };
    SuperintendentBooking.prototype.renderTag = function (text, icon, tone) {
        if (icon === void 0) { icon = null; }
        if (tone === void 0) { tone = 'neutral'; }
        return React.createElement("span", { className: "sb-tag sb-tag-" + tone },
            icon,
            text);
    };
    SuperintendentBooking.prototype.renderBookingPanel = function (slot, top, bottom, withResident) {
        if (top === void 0) { top = null; }
        if (bottom === void 0) { bottom = null; }
        if (withResident === void 0) { withResident = true; }
        var sub = this.slotSub(slot);
        return (React.createElement("div", { className: "sb-panel" },
            top,
            React.createElement("p", { className: "sb-panel-label" }, this.copy.label),
            React.createElement("p", { className: "sb-panel-date" }, formatFullDate(slot.startLocal)),
            React.createElement("p", { className: "sb-panel-time" }, this.slotTime(slot, true)),
            sub && React.createElement("p", { className: "sb-panel-sub" }, sub),
            React.createElement("hr", { className: "sb-divider" }),
            this.renderAddressRow(),
            withResident && this.renderResidentRow(),
            bottom));
    };
    SuperintendentBooking.prototype.renderHeading = function (text, className) {
        if (className === void 0) { className = ''; }
        return React.createElement("h1", { className: "sb-title " + className, ref: this.headingRef, tabIndex: -1 }, text);
    };
    SuperintendentBooking.prototype.renderBadge = function (text, icon, tone) {
        return React.createElement("span", { className: "sb-badge sb-badge-" + tone },
            icon,
            text);
    };
    SuperintendentBooking.prototype.renderCallBox = function (lead, purpose) {
        return (React.createElement("div", { className: "sb-callbox" },
            React.createElement("p", { className: "sb-callbox-lead" }, lead),
            React.createElement("p", { className: "sb-callbox-number" }, CONTACT_PHONE),
            React.createElement("a", { className: "sb-btn sb-btn-primary sb-btn-block", href: CONTACT_PHONE_HREF, "aria-label": "Call now: " + CONTACT_PHONE + " " + purpose },
                React.createElement(PhoneIcon, { size: 22 }),
                "Call now")));
    };
    SuperintendentBooking.prototype.renderAddressLine = function () {
        var detail = this.props.detail;
        var address = formatAddress(detail === null || detail === void 0 ? void 0 : detail.location);
        if (!address) {
            return null;
        }
        return React.createElement("p", { className: "sb-meta-line" },
            React.createElement(PinIcon, null),
            address);
    };
    SuperintendentBooking.prototype.renderAddressRow = function (className) {
        var _a;
        if (className === void 0) { className = ''; }
        var location = (_a = this.props.detail) === null || _a === void 0 ? void 0 : _a.location;
        if (!location) {
            return null;
        }
        return (React.createElement("div", { className: "sb-row " + className },
            React.createElement(PinIcon, { className: "sb-row-icon" }),
            React.createElement("div", null,
                React.createElement("div", { className: "sb-row-main" }, formatStreet(location)),
                React.createElement("div", { className: "sb-row-sub" }, formatCityState(location)))));
    };
    SuperintendentBooking.prototype.renderResidentRow = function () {
        var _a, _b;
        var fullName = (_b = (_a = this.props.detail) === null || _a === void 0 ? void 0 : _a.resident) === null || _b === void 0 ? void 0 : _b.fullName;
        if (!fullName) {
            return null;
        }
        return (React.createElement("div", { className: "sb-row" },
            React.createElement(PersonIcon, { className: "sb-row-icon" }),
            React.createElement("div", { className: "sb-row-main sb-row-plain" }, fullName)));
    };
    SuperintendentBooking.prototype.renderSlotDetails = function (slot) {
        var sub = this.slotSub(slot);
        return (React.createElement("div", { className: "sb-panel" },
            React.createElement("div", { className: "sb-row" },
                React.createElement(CalendarIcon, { className: "sb-row-icon" }),
                React.createElement("div", { className: "sb-row-main" }, formatLongDate(slot.startLocal))),
            React.createElement("div", { className: "sb-row" },
                React.createElement(ClockIcon, { className: "sb-row-icon" }),
                React.createElement("div", null,
                    React.createElement("div", { className: "sb-row-main" }, this.slotTime(slot, true)),
                    sub && React.createElement("div", { className: "sb-row-sub" }, sub))),
            this.renderAddressRow()));
    };
    SuperintendentBooking.prototype.renderError = function () {
        var errorMessage = this.props.errorMessage;
        if (!errorMessage) {
            return null;
        }
        return React.createElement("div", { className: "sb-alert", role: "alert" },
            React.createElement("p", { className: "sb-alert-text" }, errorMessage));
    };
    Object.defineProperty(SuperintendentBooking.prototype, "isReschedulingBooking", {
        get: function () {
            var _a;
            return !!(this.props.isRescheduling && ((_a = this.props.detail) === null || _a === void 0 ? void 0 : _a.booking));
        },
        enumerable: false,
        configurable: true
    });
    // Shared top of every reschedule "pick" state (loading, failed, picking): the current time stays visible.
    SuperintendentBooking.prototype.renderRescheduleHeader = function (withHeadingRef) {
        if (withHeadingRef === void 0) { withHeadingRef = true; }
        var _a = this.props, detail = _a.detail, cancelReschedule = _a.cancelReschedule;
        var booking = detail.booking;
        var title = "Pick a new time for your " + this.copy.name;
        return (React.createElement(React.Fragment, null,
            React.createElement("button", { type: "button", className: "sb-back", onClick: function () { return cancelReschedule(); } },
                React.createElement(ChevronLeftIcon, null),
                "Back to your appointment"),
            withHeadingRef ? this.renderHeading(title) : React.createElement("h1", { className: "sb-title" }, title),
            React.createElement("div", { className: "sb-current" },
                React.createElement("p", { className: "sb-current-time" },
                    this.renderTag('Current time'),
                    React.createElement("strong", null, formatShortDate(booking.startLocal) + " \u00B7 " + this.slotTime(booking, true))),
                React.createElement("p", { className: "sb-current-note" }, "It stays booked until you confirm a new time."))));
    };
    SuperintendentBooking.prototype.renderLoading = function () {
        var detail = this.props.detail;
        var isBookable = (detail === null || detail === void 0 ? void 0 : detail.status) === SuperintendentBookingStatus.Bookable;
        var loadingText = 'Loading…';
        if (isBookable) {
            loadingText = this.isReschedulingBooking ? 'Finding new times for you…' : 'Finding the best times for you…';
        }
        return (React.createElement("div", { className: "sb-card-body" },
            isBookable && this.isReschedulingBooking && this.renderRescheduleHeader(false),
            isBookable && !this.isReschedulingBooking && (React.createElement(React.Fragment, null,
                React.createElement("h1", { className: "sb-title" }, this.pickTitle()),
                React.createElement("p", { className: "sb-lead" }, this.copy.intro))),
            React.createElement("p", { className: "sb-loading-text", role: "status" }, loadingText),
            React.createElement("div", { className: "sb-skeleton sb-skeleton-heading" }),
            [0, 1, 2].map(function (index) { return (React.createElement("div", { className: "sb-skeleton-card", key: index, "aria-hidden": "true" },
                React.createElement("div", { className: "sb-skeleton sb-skeleton-line-short" }),
                React.createElement("div", { className: "sb-skeleton sb-skeleton-line" }))); })));
    };
    SuperintendentBooking.prototype.renderLoadError = function () {
        var _a = this.props, detail = _a.detail, retry = _a.retry;
        if (this.isReschedulingBooking) {
            return (React.createElement("div", { className: "sb-card-body" },
                this.renderRescheduleHeader(),
                React.createElement("div", { className: "sb-alert", role: "alert" },
                    React.createElement("p", { className: "sb-alert-title" }, "We couldn't load new times"),
                    React.createElement("p", { className: "sb-alert-text" }, "Your current appointment hasn't changed. Check your internet connection, then try again.")),
                React.createElement("button", { type: "button", className: "sb-btn sb-btn-primary sb-btn-block", onClick: function () { return retry(); } }, "Try Again"),
                React.createElement("p", { className: "sb-note" },
                    "Still not working? Call ",
                    React.createElement("a", { className: "sb-link", href: CONTACT_PHONE_HREF }, CONTACT_PHONE),
                    " and we'll change it with you.")));
        }
        var title = (detail === null || detail === void 0 ? void 0 : detail.status) === SuperintendentBookingStatus.Bookable ? this.pickTitle() : 'Schedule your visit';
        return (React.createElement("div", { className: "sb-card-body" },
            this.renderHeading(title),
            React.createElement("div", { className: "sb-alert", role: "alert" },
                React.createElement("p", { className: "sb-alert-title" }, detail ? "We couldn't load the available times" : "We couldn't load this page"),
                React.createElement("p", { className: "sb-alert-text" }, "Check your internet connection, then try again.")),
            React.createElement("button", { type: "button", className: "sb-btn sb-btn-primary sb-btn-block", onClick: function () { return retry(); } }, "Try Again"),
            React.createElement("p", { className: "sb-note" },
                "Still not working? Call ",
                React.createElement("a", { className: "sb-link", href: CONTACT_PHONE_HREF }, CONTACT_PHONE),
                " and we'll schedule it with you.")));
    };
    SuperintendentBooking.prototype.pickTitle = function () {
        return (this.props.isRescheduling ? 'Choose a new time' : 'Choose a time') + " for your " + this.copy.name;
    };
    SuperintendentBooking.prototype.renderRecommended = function (slots) {
        var _this = this;
        var _a;
        var _b = this.props, selectedSlot = _b.selectedSlot, selectSlot = _b.selectSlot, detail = _b.detail;
        var zone = (_a = slots[0]) === null || _a === void 0 ? void 0 : _a.timeZone;
        var zoneSentence = (detail === null || detail === void 0 ? void 0 : detail.timeZoneName) && zone ? " All times are " + detail.timeZoneName + " (" + zone + ")." : '';
        return (React.createElement("section", { className: "sb-section", "aria-labelledby": "sb-recommended-heading" },
            React.createElement("h2", { className: "sb-section-title", id: "sb-recommended-heading" }, "Recommended times"),
            React.createElement("p", { className: "sb-section-text" }, "" + this.recommendedIntro() + zoneSentence),
            React.createElement("div", { className: "sb-options", role: "radiogroup", "aria-labelledby": "sb-recommended-heading" }, slots.map(function (slot) {
                var checked = (selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.startUtc) === slot.startUtc;
                return (React.createElement("label", { key: slot.startUtc, className: "sb-option " + (checked ? 'is-selected' : '') },
                    React.createElement("input", { type: "radio", name: "sb-slot", className: "sb-option-input", checked: checked, "aria-label": _this.slotLabel(slot), onChange: function () { return selectSlot(slot); } }),
                    React.createElement("span", { className: "sb-option-text" },
                        React.createElement("span", { className: "sb-option-date" }, formatShortDate(slot.startLocal)),
                        React.createElement("span", { className: "sb-option-time" }, _this.slotTime(slot))),
                    checked
                        ? React.createElement(CheckCircleIcon, { className: "sb-radio-check", size: 28 })
                        : React.createElement("span", { className: "sb-radio", "aria-hidden": "true" })));
            }))));
    };
    SuperintendentBooking.prototype.recommendedIntro = function () {
        if (!this.isReschedulingBooking) {
            return 'These are the soonest open times.';
        }
        return this.copy.isArrivalWindow
            ? 'Your superintendent will already be in your area during these windows. They’ll arrive any time in the window you pick.'
            : 'Your superintendent will already be in your area at these times.';
    };
    // Spoken form for screen readers: full day, "to" instead of an en dash, and the time zone.
    SuperintendentBooking.prototype.slotLabel = function (slot) {
        return formatLongDate(slot.startLocal) + ", " + this.slotTime(slot, true).replace(' – ', ' to ');
    };
    SuperintendentBooking.prototype.moreTimesIntro = function (count, recommendedDuration) {
        if (this.isReschedulingBooking) {
            var unit = this.copy.isArrivalWindow ? 'arrival window' : 'time';
            return count + " more " + unit + (count === 1 ? '' : 's') + " with your superintendent, by day.";
        }
        var each = recommendedDuration ? " Each visit is about " + recommendedDuration + "." : '';
        return count + " more time" + (count === 1 ? '' : 's') + ", by day." + each;
    };
    SuperintendentBooking.prototype.renderMoreTimes = function () {
        var _this = this;
        var _a = this.pickProps(), timeOptions = _a.timeOptions, selectedSlot = _a.selectedSlot, selectSlot = _a.selectSlot, recommendedDuration = _a.recommendedDuration;
        // While rescheduling, chips show the whole range so the new time reads the same as the current one.
        var showRange = this.isReschedulingBooking;
        return (React.createElement("section", { className: "sb-section", id: "sb-more-times", "aria-labelledby": "sb-more-heading" },
            React.createElement("h2", { className: "sb-section-title", id: "sb-more-heading", tabIndex: -1, ref: this.moreHeadingRef }, "More times"),
            React.createElement("p", { className: "sb-section-text" }, this.moreTimesIntro(timeOptions.moreCount, recommendedDuration)),
            timeOptions.moreDays.map(function (day) { return (React.createElement("div", { className: "sb-day", key: day.date },
                React.createElement("h3", { className: "sb-day-title", id: "sb-day-" + day.date }, formatDayHeading(day.date)),
                React.createElement("div", { className: "sb-times " + (showRange ? 'sb-times-wide' : ''), role: "group", "aria-labelledby": "sb-day-" + day.date }, day.slots.map(function (slot) {
                    var isSelected = (selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.startUtc) === slot.startUtc;
                    return (React.createElement("button", { type: "button", key: slot.startUtc, className: "sb-time " + (isSelected ? 'is-selected' : ''), "aria-pressed": isSelected, "aria-label": _this.slotLabel(slot), onClick: function () { return selectSlot(slot); } },
                        isSelected && React.createElement(CheckIcon, { size: 16 }),
                        showRange ? _this.chipRange(slot) : formatClock(slot.startLocal)));
                })))); })));
    };
    SuperintendentBooking.prototype.renderNoneWork = function () {
        var keepNote = this.isReschedulingBooking ? ' Your current appointment stays booked until then.' : '';
        return (React.createElement("div", { className: "sb-help" },
            React.createElement("h2", { className: "sb-help-title" }, "None of these times work?"),
            React.createElement("p", { className: "sb-help-text" }, "Call us and we'll find a time with you." + keepNote),
            React.createElement("a", { className: "sb-btn sb-btn-outline sb-btn-block", href: CONTACT_PHONE_HREF, "aria-label": "Call " + CONTACT_PHONE + " to " + (this.isReschedulingBooking ? 'change' : 'schedule') + " your " + this.copy.name },
                React.createElement(PhoneIcon, null), "Call " + CONTACT_PHONE)));
    };
    Object.defineProperty(SuperintendentBooking.prototype, "pickableTimeOptions", {
        // The current appointment can't be picked as its own replacement, so it is left out of every list.
        get: function () {
            var timeOptions = this.props.timeOptions;
            if (!timeOptions) {
                return timeOptions;
            }
            var isOpen = function (slot) { return !slot.isCurrent; };
            var moreDays = timeOptions.moreDays
                .map(function (day) { return (__assign(__assign({}, day), { slots: day.slots.filter(isOpen) })); })
                .filter(function (day) { return day.slots.length > 0; });
            var removed = timeOptions.moreDays.reduce(function (total, day) { return total + day.slots.length; }, 0)
                - moreDays.reduce(function (total, day) { return total + day.slots.length; }, 0);
            return {
                moreDays: moreDays,
                recommended: timeOptions.recommended.filter(isOpen),
                moreCount: Math.max(timeOptions.moreCount - removed, 0)
            };
        },
        enumerable: false,
        configurable: true
    });
    SuperintendentBooking.prototype.pickProps = function () {
        var _a;
        var _b = this.props, selectedSlot = _b.selectedSlot, selectSlot = _b.selectSlot;
        var timeOptions = this.pickableTimeOptions;
        var first = (timeOptions === null || timeOptions === void 0 ? void 0 : timeOptions.recommended[0]) || ((_a = timeOptions === null || timeOptions === void 0 ? void 0 : timeOptions.moreDays[0]) === null || _a === void 0 ? void 0 : _a.slots[0]);
        // An arrival window's length is not how long the visit takes, so move-out gets no duration phrase.
        var recommendedDuration = first && !this.copy.isArrivalWindow ? formatDurationPhrase(first) : '';
        return { timeOptions: timeOptions, selectedSlot: selectedSlot, selectSlot: selectSlot, recommendedDuration: recommendedDuration };
    };
    SuperintendentBooking.prototype.renderPick = function () {
        var _a = this.props, isMoreTimesOpen = _a.isMoreTimesOpen, toggleMoreTimes = _a.toggleMoreTimes, selectedSlot = _a.selectedSlot, goToConfirm = _a.goToConfirm, isSelectionMissing = _a.isSelectionMissing;
        var _b = this.pickProps(), timeOptions = _b.timeOptions, recommendedDuration = _b.recommendedDuration;
        var hasRecommended = !!timeOptions && timeOptions.recommended.length > 0;
        var hasMore = !!timeOptions && timeOptions.moreDays.length > 0;
        var hasSlots = hasRecommended || hasMore;
        // With nothing to recommend (e.g. the current time was the only pick), the other times show straight away.
        var showMore = hasMore && (isMoreTimesOpen || !hasRecommended);
        var isReschedulingBooking = this.isReschedulingBooking;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "sb-card-body" },
                isReschedulingBooking ? this.renderRescheduleHeader() : (React.createElement(React.Fragment, null,
                    this.renderHeading(this.pickTitle()),
                    React.createElement("p", { className: "sb-lead" },
                        this.copy.intro,
                        recommendedDuration && " It takes about " + recommendedDuration + "."),
                    this.renderAddressLine())),
                this.renderError(),
                !hasSlots && (React.createElement("section", { className: "sb-section" },
                    React.createElement("h2", { className: "sb-section-title" }, "No times available online"),
                    React.createElement("p", { className: "sb-section-text" },
                        "We couldn't find an open time in your scheduling window.",
                        isReschedulingBooking && ' Your current appointment stays booked.'),
                    isReschedulingBooking
                        ? this.renderCallBox("One quick call and we'll find a new time with you.", "to change your " + this.copy.name)
                        : this.renderCallBox("One quick call and we'll schedule it with you.", "to schedule your " + this.copy.name))),
                hasRecommended && this.renderRecommended(timeOptions.recommended),
                hasRecommended && hasMore && !showMore && (React.createElement("button", { type: "button", className: "sb-btn sb-btn-outline sb-btn-block", "aria-expanded": false, "aria-controls": "sb-more-times", onClick: function () { return toggleMoreTimes(); } }, "See More Times")),
                showMore && this.renderMoreTimes(),
                hasSlots && (!hasMore || showMore) && this.renderNoneWork()),
            hasSlots && (React.createElement("div", { className: "sb-card-footer" },
                isReschedulingBooking && selectedSlot && (React.createElement("p", { className: "sb-footer-summary" },
                    "New time: ",
                    React.createElement("strong", null, formatShortDate(selectedSlot.startLocal) + " \u00B7 " + this.slotTime(selectedSlot, true)))),
                isSelectionMissing && !selectedSlot && (React.createElement("p", { className: "sb-validation", role: "alert" }, isReschedulingBooking ? 'Choose a new time above to continue.' : 'Choose a time above to continue.')),
                React.createElement("button", { type: "button", className: "sb-btn sb-btn-primary sb-btn-block", onClick: function () { return goToConfirm(); } }, "Continue")))));
    };
    SuperintendentBooking.prototype.renderRescheduleConfirm = function () {
        var _a = this.props, selectedSlot = _a.selectedSlot, isBooking = _a.isBooking, book = _a.book, backToPick = _a.backToPick, cancelReschedule = _a.cancelReschedule, detail = _a.detail;
        var booking = detail.booking;
        var replaces = (React.createElement(React.Fragment, null,
            React.createElement("hr", { className: "sb-divider" }),
            this.renderTag('Replaces your current time'),
            React.createElement("p", { className: "sb-panel-sub" }, formatFullDate(booking.startLocal) + " \u00B7 " + this.slotTime(booking, true))));
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "sb-card-body" },
                React.createElement("button", { type: "button", className: "sb-back", disabled: isBooking, onClick: function () { return backToPick(); } },
                    React.createElement(ChevronLeftIcon, null),
                    "Back to times"),
                this.renderHeading('Confirm your new time'),
                React.createElement("p", { className: "sb-lead" }, "Your " + this.copy.name + " will move to the new time below."),
                this.props.errorMessage && (React.createElement("div", { className: "sb-alert", role: "alert" },
                    React.createElement("p", { className: "sb-alert-title" }, "We couldn't change your time"),
                    React.createElement("p", { className: "sb-alert-text" }, this.props.errorMessage + " Try again, or call ",
                        React.createElement("a", { className: "sb-link", href: CONTACT_PHONE_HREF }, CONTACT_PHONE),
                        "."))),
                React.createElement("div", { role: "group", "aria-label": "Appointment change" }, this.renderBookingPanel(selectedSlot, this.renderTag('New time', React.createElement(CheckIcon, { size: 14 }), 'success'), replaces)),
                this.copy.beforeVisit && (React.createElement("section", { className: "sb-help", "aria-labelledby": "sb-before-heading" },
                    React.createElement("h2", { className: "sb-help-title", id: "sb-before-heading" }, "Before your visit"),
                    React.createElement("ul", { className: "sb-list" }, this.copy.beforeVisit.map(function (item) { return React.createElement("li", { key: item }, item); })))),
                React.createElement("p", { className: "sb-note" }, "Not sure? Keep your current time and nothing changes.")),
            React.createElement("div", { className: "sb-card-footer" },
                isBooking && React.createElement("p", { className: "sb-footer-summary", role: "status" }, "Saving your new time\u2026"),
                React.createElement("button", { type: "button", className: "sb-btn sb-btn-primary sb-btn-block", disabled: isBooking, onClick: function () { return book(); } },
                    "Confirm New Time",
                    isBooking && React.createElement(Dot, null)),
                React.createElement("button", { type: "button", className: "sb-btn sb-btn-text sb-btn-block", disabled: isBooking, onClick: function () { return cancelReschedule(); } }, "Keep Current Time"))));
    };
    SuperintendentBooking.prototype.renderConfirm = function () {
        var _a = this.props, selectedSlot = _a.selectedSlot, isBooking = _a.isBooking, book = _a.book, backToPick = _a.backToPick;
        if (this.isReschedulingBooking) {
            return this.renderRescheduleConfirm();
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "sb-card-body" },
                React.createElement("button", { type: "button", className: "sb-back", disabled: isBooking, onClick: function () { return backToPick(); } },
                    React.createElement(ChevronLeftIcon, null),
                    "Back to times"),
                this.renderHeading("Confirm your " + this.copy.name),
                React.createElement("p", { className: "sb-lead" }, "Check the details, then book."),
                this.renderError(),
                this.renderSlotDetails(selectedSlot),
                this.cutoff && (React.createElement("p", { className: "sb-note" }, "Plans change? You can pick a new time with this same link until " + this.cutoff + "."))),
            React.createElement("div", { className: "sb-card-footer" },
                React.createElement("button", { type: "button", className: "sb-btn sb-btn-primary sb-btn-block", disabled: isBooking, onClick: function () { return book(); } },
                    "Book This Time",
                    isBooking && React.createElement(Dot, null)),
                React.createElement("button", { type: "button", className: "sb-btn sb-btn-text sb-btn-block", disabled: isBooking, onClick: function () { return backToPick(); } }, "Choose a Different Time"))));
    };
    SuperintendentBooking.prototype.calendarEvent = function () {
        var detail = this.props.detail;
        return {
            title: BRAND_NAME + " " + this.copy.name,
            slot: detail.booking,
            location: formatAddress(detail.location),
            details: "Your " + this.copy.name + " with a superintendent. Questions? Call " + CONTACT_PHONE + "."
        };
    };
    SuperintendentBooking.prototype.renderCalendarMenu = function (isBlock) {
        var _this = this;
        if (isBlock === void 0) { isBlock = false; }
        var isCalendarMenuOpen = this.state.isCalendarMenuOpen;
        var event = this.calendarEvent();
        var close = function () { return _this.setState({ isCalendarMenuOpen: false }); };
        return (React.createElement("div", { className: "sb-calendar " + (isBlock ? 'sb-calendar-block' : '') },
            React.createElement("button", { type: "button", className: isBlock ? 'sb-btn sb-btn-outline-neutral sb-btn-block sb-calendar-toggle-block' : 'sb-calendar-toggle', "aria-expanded": isCalendarMenuOpen, "aria-controls": "sb-calendar-menu", onClick: function () { return _this.setState({ isCalendarMenuOpen: !isCalendarMenuOpen }); } },
                React.createElement(CalendarPlusIcon, null),
                "Add to calendar",
                React.createElement(ChevronDownIcon, { className: isCalendarMenuOpen ? 'is-flipped' : '' })),
            isCalendarMenuOpen && (React.createElement("ul", { className: "sb-calendar-menu", id: "sb-calendar-menu" },
                React.createElement("li", null,
                    React.createElement("a", { href: getGoogleCalendarUrl(event), target: "_blank", rel: "noopener noreferrer", onClick: close }, "Google Calendar")),
                React.createElement("li", null,
                    React.createElement("a", { href: getOutlookCalendarUrl(event), target: "_blank", rel: "noopener noreferrer", onClick: close }, "Outlook")),
                React.createElement("li", null,
                    React.createElement("button", { type: "button", onClick: function () { downloadIcs(event); close(); } }, "Apple / other (.ics file)"))))));
    };
    SuperintendentBooking.prototype.renderBooked = function () {
        var detail = this.props.detail;
        return (React.createElement("div", { className: "sb-card-body sb-center-top" },
            React.createElement("div", { className: "sb-success-mark", "aria-hidden": "true" },
                React.createElement(CheckCircleIcon, { size: 72 })),
            this.renderHeading("You're booked", 'sb-text-center'),
            React.createElement("p", { className: "sb-lead sb-text-center" }, "Your " + this.copy.name + " is scheduled. " + BRAND_NAME + " will email you a confirmation."),
            this.renderSlotDetails(detail.booking),
            this.renderCalendarMenu(),
            React.createElement("h2", { className: "sb-section-title" }, "Need to change it?"),
            React.createElement("p", { className: "sb-section-text" },
                "Open this same link again to pick a new time.",
                this.cutoff && " You can do this until " + this.cutoff + ".")));
    };
    SuperintendentBooking.prototype.renderRescheduled = function () {
        var _a = this.props, detail = _a.detail, replacedBooking = _a.replacedBooking;
        var replaces = (React.createElement("p", { className: "sb-panel-sub sb-panel-replaces" }, "Replaces " + formatShortDate(replacedBooking.startLocal) + " \u00B7 " + this.slotTime(replacedBooking, true)));
        return (React.createElement("div", { className: "sb-card-body sb-center-top" },
            React.createElement("div", { className: "sb-success-mark", "aria-hidden": "true" },
                React.createElement(CheckCircleIcon, { size: 72 })),
            this.renderHeading('Your time is changed', 'sb-text-center'),
            React.createElement("p", { className: "sb-lead sb-text-center" }, "Your " + this.copy.name + " has moved to the new time. " + BRAND_NAME + " will email you a confirmation."),
            this.renderBookingPanel(detail.booking, null, replaces, false),
            this.renderCalendarMenu(true),
            React.createElement("h2", { className: "sb-section-title" }, "Need to change it again?"),
            React.createElement("p", { className: "sb-section-text" },
                "Open this same link again.",
                this.cutoff && " You can change it online until " + this.cutoff + ".")));
    };
    SuperintendentBooking.prototype.renderScheduled = function () {
        var _a = this.props, detail = _a.detail, startReschedule = _a.startReschedule;
        return (React.createElement("div", { className: "sb-card-body" },
            this.renderBadge('Booked', React.createElement(CheckCircleIcon, { size: 18 }), 'success'),
            this.renderHeading("You're all set"),
            React.createElement("p", { className: "sb-lead" }, "Here are the details for your " + this.copy.name + "."),
            this.renderError(),
            this.renderBookingPanel(detail.booking),
            React.createElement("h2", { className: "sb-section-title" }, "Need a different time?"),
            this.cutoff && React.createElement("p", { className: "sb-section-text" }, "You can change it online until " + this.cutoff + "."),
            React.createElement("button", { type: "button", className: "sb-btn sb-btn-outline-neutral sb-btn-block", onClick: function () { return startReschedule(); } }, "Reschedule")));
    };
    // Any expired link (window closed or link expired) gets this one screen: no appointment details, just the call path.
    SuperintendentBooking.prototype.renderExpired = function () {
        var _a;
        var detail = this.props.detail;
        var closedOn = (detail === null || detail === void 0 ? void 0 : detail.bookingWindowEnd) || (detail === null || detail === void 0 ? void 0 : detail.bookingClosedOn) || (detail === null || detail === void 0 ? void 0 : detail.expiresAt);
        var days = getWindowDays(detail === null || detail === void 0 ? void 0 : detail.bookingWindowStart, detail === null || detail === void 0 ? void 0 : detail.bookingWindowEnd);
        var windowName = days ? "The " + days + "-day window" : 'The window';
        var ended = closedOn
            ? windowName + " to schedule online ended on " + formatClosedDate(closedOn) + "."
            : windowName + " to schedule online has ended.";
        return (React.createElement("div", { className: "sb-card-body" },
            this.renderBadge('Online scheduling closed', React.createElement(ClockIcon, { size: 18 }), 'neutral'),
            this.renderHeading("Online scheduling for your " + this.copy.name + " has closed"),
            React.createElement("p", { className: "sb-lead" }, ended),
            this.renderCallBox("One quick call and we'll schedule it with you.", "to schedule your " + this.copy.name),
            ((detail === null || detail === void 0 ? void 0 : detail.location) || ((_a = detail === null || detail === void 0 ? void 0 : detail.resident) === null || _a === void 0 ? void 0 : _a.fullName)) && (React.createElement("section", { className: "sb-visit", "aria-labelledby": "sb-visit-heading" },
                React.createElement("h2", { className: "sb-visit-title", id: "sb-visit-heading" }, "Your visit"),
                React.createElement("div", { className: "sb-panel sb-visit-panel" },
                    React.createElement("div", { className: "sb-row" },
                        React.createElement(HomeIcon, { className: "sb-row-icon" }),
                        React.createElement("div", { className: "sb-row-main" }, this.copy.label)),
                    this.renderResidentRow(),
                    this.renderAddressRow())))));
    };
    SuperintendentBooking.prototype.renderCancelled = function () {
        var booking = this.props.detail.cancelledBooking;
        var when = booking
            ? " set for " + formatShortDate(booking.startLocal) + " at " + formatClock(booking.startLocal) + (booking.timeZone ? " " + booking.timeZone : '')
            : '';
        return (React.createElement("div", { className: "sb-card-body" },
            this.renderBadge('Cancelled', React.createElement(XCircleIcon, { size: 18 }), 'neutral'),
            this.renderHeading("Your " + this.copy.name + " was cancelled"),
            React.createElement("p", { className: "sb-lead" }, "Our local team cancelled the " + this.copy.name + when + ". This link can no longer be used to schedule."),
            this.renderCallBox('Have questions or need to schedule again? Call us.', "about your cancelled " + this.copy.name),
            this.renderAddressLine()));
    };
    SuperintendentBooking.prototype.renderNotRecognized = function () {
        return (React.createElement("div", { className: "sb-card-body" },
            this.renderBadge('Link not recognized', React.createElement(LinkOffIcon, { size: 18 }), 'neutral'),
            this.renderHeading("We couldn't open this link"),
            React.createElement("p", { className: "sb-lead" }, "It may be incomplete or out of date."),
            React.createElement("h2", { className: "sb-section-title" }, "Try this first"),
            React.createElement("p", { className: "sb-body-text" }, "Open the most recent email or text from " + BRAND_NAME + " and tap the link there. If you copied the link, make sure you copied all of it."),
            React.createElement("h2", { className: "sb-section-title" }, "Still not working?"),
            React.createElement("p", { className: "sb-section-text" }, "Call us and we'll help you schedule."),
            React.createElement("a", { className: "sb-btn sb-btn-primary sb-btn-block sb-btn-large", href: CONTACT_PHONE_HREF },
                React.createElement(PhoneIcon, { size: 24 }), "Call " + CONTACT_PHONE)));
    };
    SuperintendentBooking.prototype.renderScreen = function (screen) {
        switch (screen) {
            case 'loadError': return this.renderLoadError();
            case 'pick': return this.renderPick();
            case 'confirm': return this.renderConfirm();
            case 'booked': return this.renderBooked();
            case 'rescheduled': return this.renderRescheduled();
            case 'scheduled': return this.renderScheduled();
            case 'cancelled': return this.renderCancelled();
            case 'expired': return this.renderExpired();
            case 'notRecognized': return this.renderNotRecognized();
            default: return this.renderLoading();
        }
    };
    SuperintendentBooking.prototype.render = function () {
        var screen = this.getScreen();
        return (React.createElement("div", { className: "superintendent-booking" },
            React.createElement("header", { className: "sb-header" },
                React.createElement("div", { className: "sb-header-inner" },
                    React.createElement("span", { className: "sb-brand" }, BRAND_NAME))),
            React.createElement("main", { className: "sb-main" },
                React.createElement("div", { className: "sb-card", "aria-busy": screen === 'loading' }, this.renderScreen(screen)))));
    };
    SuperintendentBooking = __decorate([
        withRouter,
        inject(SuperintendentBookingBusiness),
        observer
    ], SuperintendentBooking);
    return SuperintendentBooking;
}(React.Component));
export default SuperintendentBooking;
